import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DesktopHeaderComponent } from './header/desktop-header/desktop-header.component';
import { NavigationComponent } from './navigation/navigation.component';
import { SuggestedStagesComponent } from './suggested-stages/suggested-stages.component';
import { SuggestedPostsComponent } from './suggested-posts/suggested-posts.component';
import { DesktopFullscreenComponent } from './modals/desktop-fullscreen/desktop-fullscreen.component';
import { LinksComponent } from './links/links.component';
import { HeaderComponent } from './header/header.component';
import { MobileHeaderComponent } from './header/mobile-header/mobile-header.component';
import { StreamComponent } from './stream/stream.component';
import { MobileFullscreenComponent } from './modals/mobile-fullscreen/mobile-fullscreen.component';
import { ShareComponent } from './modals/share/share.component';
import { ConsentComponent } from './modals/consent/consent.component';
import { MobileNavigationComponent } from './navigation/mobile-navigation/mobile-navigation.component';
import { InstallationComponent } from './installation/installation.component';
import { FollowedToolbarComponent } from './followed-toolbar/followed-toolbar.component';
import { MobilePopoverComponent } from './modals/mobile-popover/mobile-popover.component';
import { SourcesComponent } from './sources/sources.component';
import { StageButtonComponent } from './components/stage-button/stage-button.component';
import { FilterBarComponent } from './components/filter-bar/filter-bar.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { StageTooltipComponent } from './tooltips/stage-tooltip/stage-tooltip.component';
import { AITooltipComponent } from './tooltips/ai-tooltip/ai-tooltip.component';
import { LinkedStagesTooltipComponent } from './tooltips/linked-stages-tooltip/linked-stages-tooltip.component';
import { SourcesTooltipComponent } from './tooltips/sources-tooltip/sources-tooltip.component';
import { StoriesComponent } from './modals/stories/stories.component';
import { StoryComponent } from './components/story/story.component';
import { StageComponentsModule } from '@jaimo-solutions-gmbh/stage-components';
import { InitialStreamComponent } from './components/initial-stream/initial-stream.component';
import { SearchResultsComponent } from './components/search-results/search-results.component';
import { NgxMasonryModule } from 'ngx-masonry';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { InfiniteSpinnerComponent } from './components/infinite-spinner/infinite-spinner.component';
import {
  TippyDirective,
  popperVariation,
  provideTippyConfig,
  tooltipVariation,
} from '@ngneat/helipopper';
import { AccountTileComponent } from './components/account-tile/account-tile.component';
import { BannerComponent } from './banner/banner.component';
import { ProfileActionsComponent } from './components/profile-actions/profile-actions.component';

@NgModule({
  imports: [
    TippyDirective,
    CommonModule,
    FormsModule,
    IonicModule,
    StageComponentsModule,
    InfiniteScrollModule,
    NgxMasonryModule,
  ],
  declarations: [
    DesktopHeaderComponent,
    StageButtonComponent,
    AccountTileComponent,
    NavigationComponent,
    LinkedStagesTooltipComponent,
    InfiniteSpinnerComponent,
    AITooltipComponent,
    FilterBarComponent,
    SuggestedStagesComponent,
    StreamComponent,
    FollowedToolbarComponent,
    TabsComponent,
    HeaderComponent,
    SuggestedPostsComponent,
    StageTooltipComponent,
    MobileFullscreenComponent,
    MobileNavigationComponent,
    MobileHeaderComponent,
    DesktopFullscreenComponent,
    ProfileActionsComponent,
    LinksComponent,
    SourcesTooltipComponent,
    InstallationComponent,
    ShareComponent,
    ConsentComponent,
    StoriesComponent,
    MobilePopoverComponent,
    BannerComponent,
    SourcesComponent,
    StoryComponent,
    SearchInputComponent,
    StageButtonComponent,
    InitialStreamComponent,
    SearchResultsComponent,
  ],
  exports: [
    DesktopHeaderComponent,
    LinkedStagesTooltipComponent,
    StageButtonComponent,
    NavigationComponent,
    InfiniteSpinnerComponent,
    SuggestedStagesComponent,
    AccountTileComponent,
    SearchInputComponent,
    StoryComponent,
    BannerComponent,
    FollowedToolbarComponent,
    StreamComponent,
    TabsComponent,
    HeaderComponent,
    StoriesComponent,
    SuggestedPostsComponent,
    MobileFullscreenComponent,
    MobileNavigationComponent,
    ProfileActionsComponent,
    MobileHeaderComponent,
    DesktopFullscreenComponent,
    MobilePopoverComponent,
    SourcesTooltipComponent,
    LinksComponent,
    FilterBarComponent,
    InstallationComponent,
    ShareComponent,
    ConsentComponent,
    SourcesComponent,
    AITooltipComponent,
    StageButtonComponent,
    InitialStreamComponent,
    SearchResultsComponent,
  ],
  providers: [
    provideTippyConfig({
      defaultVariation: 'tooltip',
      variations: {
        tooltip: tooltipVariation,
        popper: popperVariation,
      },
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
